import React from "react";

import TextInput from "../text-input";

export const EmailInput: React.FC<React.ComponentProps<typeof TextInput>> = (
  props
) => <TextInput type="email" {...props} />;
export default EmailInput;
